<template>
    <PageWrapper 
        navTitle="Meet the team"
        navTitleId="meet-team-title"
        routeName="member"
        :items="members"
        :backButton="{
            route: backButton.backRoute,
            label: backButton.backLabel,
        }"
        :reverse="isIndex"
    >

        <template v-slot:body>
            <router-view :key="$route.path" />
        </template>

    </PageWrapper>
</template>

<script>
import { gsap } from 'gsap'

import PageWrapper from '../PageWrapper'
import innerBackButton from '@/mixins/lib/innerBackButton'
import { focusOrderWatcher } from '@/mixins/focusOrder'

export default {
    name: 'Team',
    metaInfo: {
        title: 'Connect with Us',
    },
    
    components: {
        PageWrapper,
    },
    
    mixins: [
        focusOrderWatcher,
    ],
    
    beforeRouteUpdate( to, from, next ) {
        gsap.to( document.body, {
            scrollTop: 0,
            duration: .75,
            ease: 'expo',
            onComplete: next
        })
    },
    
    computed: {
        members() {
            return this.$store.getters.members
        },
        isIndex() {
            const { path } = this.$route
            return path.endsWith('connect-with-us') || path.endsWith('connect-with-us/')
        },
        backButton() {
            const { path } = this.$route
            
            const parentRoute = {
                path: 'connect-with-us',
                label: 'Back to Connect with Us'
            }

            return innerBackButton( path, parentRoute )
        }
    },
}
</script>
